import { Component, Inject, OnInit,OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";
import { Subscription } from "rxjs";
import { BroadcastMessageEvent } from "src/app/core/constants/BroadcastMessageEvent";
import { MessageBroadcastService } from "src/app/services/message-broadcast.service";

@Component({
    selector: 'app-send-package-success-dialog',
    templateUrl: './send-package-success-dialog.component.html',
    styleUrls: ['./send-package-success-dialog.component.scss'],

})
export class SendPackageSuccessDialogComponent implements OnInit,OnDestroy {
    public productTypeText = '';
    public packageFileNameText = '';
    assetSuccessText = '';
    assetAdditionalErrorText= '';
    private dailogCloseSubscription: Subscription;
    constructor(@Inject(MAT_DIALOG_DATA) public packageList: any, private matDialogRef: MatDialogRef<SendPackageSuccessDialogComponent>,
     private translocoService: TranslocoService, private messageBroadcastService: MessageBroadcastService){
        this.dailogCloseSubscription = this.messageBroadcastService.getSubscription(BroadcastMessageEvent.patchDeploymentDialogUserAction).subscribe((result) => {
          if(this.packageList.patchFile == result?.patchFile && this.packageList.deviceId?.toLowerCase() == result?.deviceId?.toLowerCase())
            this.cancel(false);
        });
    }
    ngOnInit(){
        console.log(this.packageList);
        this.assetSuccessText =  this.translocoService.translateObject("patchUploadSuccess", { productName: this.packageList.deviceId, packageName: this.packageList.patchFile });     
    }
    cancel(raiseBroadcastEvent = true) {
        if (raiseBroadcastEvent) {
            this.messageBroadcastService.broadCast({ event: BroadcastMessageEvent.patchDeploymentDialogUserAction, data: { patchFile: this.packageList?.patchFile, deviceId: this.packageList?.deviceId } });
        }
        this.matDialogRef.close(false);
    }
    ngOnDestroy(): void {
        this.dailogCloseSubscription?.unsubscribe();
    }
}